import { makeAutoObservable, runInAction } from 'mobx';
import { apiClient } from '../api/apiclient';
import { academyStore } from './AcademyStore';
export class InventoryStore {
    constructor() {
        this.inventories = [];
        this.loading = false;
        this.error = null;
        this.selectedInventory = null;
        this.isDialogOpen = false;
        this.isEditing = false;
        makeAutoObservable(this);
    }
    // Actions
    async fetchInventories(academyId, filters) {
        this.loading = true;
        this.error = null;
        try {
            const response = await apiClient.getInventoriesByAcademyId(academyId, filters);
            if (response.success) {
                runInAction(() => {
                    this.inventories = response.data;
                    this.loading = false;
                });
            }
            else {
                throw new Error(response.message);
            }
        }
        catch (error) {
            runInAction(() => {
                this.error = error instanceof Error ? error.message : 'Failed to fetch inventories';
                this.loading = false;
            });
        }
    }
    async createInventory(inventoryData) {
        if (!academyStore.currentAcademy) {
            throw new Error('No academy selected');
        }
        this.loading = true;
        this.error = null;
        try {
            const response = await apiClient.createInventory(academyStore.currentAcademy.id, inventoryData);
            if (response.success) {
                runInAction(() => {
                    this.inventories.unshift(response.data);
                    this.loading = false;
                });
                return response.data;
            }
            else {
                throw new Error(response.message);
            }
        }
        catch (error) {
            runInAction(() => {
                this.error = error instanceof Error ? error.message : 'Failed to create inventory';
                this.loading = false;
            });
            throw error;
        }
    }
    async updateInventory(id, inventoryData) {
        if (!academyStore.currentAcademy) {
            throw new Error('No academy selected');
        }
        this.loading = true;
        this.error = null;
        try {
            const response = await apiClient.updateInventory(academyStore.currentAcademy.id, id, inventoryData);
            if (response.success) {
                runInAction(() => {
                    const index = this.inventories.findIndex(inventory => inventory.id === id);
                    if (index !== -1) {
                        this.inventories[index] = response.data;
                    }
                    this.loading = false;
                });
                return response.data;
            }
            else {
                throw new Error(response.message);
            }
        }
        catch (error) {
            runInAction(() => {
                this.error = error instanceof Error ? error.message : 'Failed to update inventory';
                this.loading = false;
            });
            throw error;
        }
    }
    async deleteInventory(id) {
        if (!academyStore.currentAcademy) {
            throw new Error('No academy selected');
        }
        this.loading = true;
        this.error = null;
        try {
            const response = await apiClient.deleteInventory(academyStore.currentAcademy.id, id);
            if (response.success) {
                runInAction(() => {
                    this.inventories = this.inventories.filter(inventory => inventory.id !== id);
                    this.loading = false;
                });
            }
            else {
                throw new Error(response.message);
            }
        }
        catch (error) {
            runInAction(() => {
                this.error = error instanceof Error ? error.message : 'Failed to delete inventory';
                this.loading = false;
            });
            throw error;
        }
    }
    // Dialog actions
    openCreateDialog() {
        this.selectedInventory = null;
        this.isEditing = false;
        this.isDialogOpen = true;
    }
    openEditDialog(inventory) {
        this.selectedInventory = inventory;
        this.isEditing = true;
        this.isDialogOpen = true;
    }
    closeDialog() {
        this.isDialogOpen = false;
        this.selectedInventory = null;
        this.isEditing = false;
    }
    // Computed
    get hasInventories() {
        return this.inventories.length > 0;
    }
    get isLoading() {
        return this.loading;
    }
    get hasError() {
        return this.error !== null;
    }
    get activeInventories() {
        return this.inventories.filter(inventory => inventory.active);
    }
    get inactiveInventories() {
        return this.inventories.filter(inventory => !inventory.active);
    }
}
export const inventoryStore = new InventoryStore();
